<template>

    <tr @click="onClick">
        <slot></slot>
    </tr>

</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { createComponentMixin } from '@wittignl/js-core';

@Component({
    name: 'ui-table-row',
    emits: ['click']
})
export default class TableRow extends Vue {

    @Prop({ type: Object })
    to: any;

    @Prop({ type: String })
    click: string;

    onClick(e) {

        if(this.to){

            this['$router'].push(this.to);
        }
        else if(this.click){

            for(const child of this.$el.getElementsByTagName('*')){

                const childAction = child.dataset.action;

                if(childAction === this.click){

                    child.click();
                    break;
                }
            }
        }

        this.$emit('click', e);
    }
}

export type TableRowComp = InstanceType<typeof TableRow>
export type TableRowProps = ComponentProps<TableRowComp>
export const tableRowCompMixin = createComponentMixin(TableRow)

</script>